<button pButton class="p-button p-button-sm title-action-button" [ngClass]="getButtonClass()"
        type="button" outline="true"
        (click)="clicked()" [disabled]="disable">
  <span style="margin-right: 5px;" [ngClass]="removeLabelOnMobile ? 'remove-label' : ''" *ngIf="btnText">{{ btnText }}</span><fa-icon *ngIf="btnIcon" [icon]="['far', btnIcon]" size="lg" style="margin-top: -2px"></fa-icon>
</button>
